export const NOT_AUTHENTICATED_FLAG = 'NO_AUTH'
